/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import {ValidatorFn, Validators} from "@angular/forms";

export interface BookingAppointmentPermissions { 
    add: boolean;
    change: boolean;
    destroy: boolean;
    view: boolean;
    viewPlanner: boolean;
    ignoreWarnings: boolean;
}
export const BookingAppointmentPermissions_add_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingAppointmentPermissions_change_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingAppointmentPermissions_destroy_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingAppointmentPermissions_view_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingAppointmentPermissions_viewPlanner_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingAppointmentPermissions_ignoreWarnings_Validators: ValidatorFn[] =
    [  Validators.required, ];


